<div class="enable-panel" *ngIf="!(leapIsActive$ | async)">
  <div trans>Temporarily send all visitors directly to this link.</div>
  <div trans>You can only have one active Leap Link at a time.</div>
  <button
    type="button"
    mat-flat-button
    color="accent"
    class="enable-leap-btn"
    (click)="enableLeapLink()"
    trans
  >
    Enable Leap Link
  </button>
</div>

<div class="enable-panel" *ngIf="leapIsActive$ | async">
  <div class="description" trans>Set an end time for the Leap Link. Your Biolink will automatically restore when the Leap Link expires.</div>
  <datetime-input [formControl]="leapUntilControl"></datetime-input>
  <button
    type="button"
    mat-flat-button
    color="accent"
    class="enable-leap-btn"
    (click)="disableLeapLink()"
    trans
  >
    Disable Leap Link
  </button>
</div>
